<div>Processing authentication...</div>